import React from "react";
import { SuperBlockContent } from "./super-block-content";

import "./wrapper.scss";
import classNames from "classnames";

interface Props {
  width?: "full" | "center";
  body?: any[];
}

export const Wrapper = ({ body, width }: Props) => {
  return (
    <div className="template--container">
      <SuperBlockContent
        projectId={"g3so7nt7"}
        dataset={"production"}
        className={"wrapper--container"}
        // className={classNames(
        //   "flex--container",
        //   `flex--container--${spacing}`,
        //   `flex--container--align--${align}`,
        // )}
        blocks={body}
      />
    </div>
  );
};
